<script>
import ResultRevealer from "@homepage/components/common/ResultRevealer.vue";

export default {
	name: "LeslycVipRoulette",
	props: {
		result: {
			type: Object,
			required: true,
		}
	},
	components: {
		Roulette: ResultRevealer
	},
	data() {
		return {
			settings: {
				totalBall: 50,
				spinStartSpeed: 5,
				spinEndSpeed: 5,
				spinSpeed: 10,
				revealTimer: Math.floor(Math.random() * (8 - 5 + 1)) + 5,
				rotateBalls: true,
				padNumbers: false,
				maxNumber: 10
			}
		}
	}
}
</script>

<template>
	<v-row>
		<v-col cols="4">
		</v-col>
		<v-col cols="4">
			<roulette
				v-if="result"
				:result="result"
				:settings="settings"
				:resources="{
					pick2Img: require('assets/static/img/picks/superlotto/pick2.png'),
					pick3Img: require('assets/static/img/picks/superlotto/pick3.png'),
					pick4Img: require('assets/static/img/picks/superlotto/pick4.png'),
					pick5Img: require('assets/static/img/picks/superlotto/pick5.png')
				}"
				@finish="$emit('finish')"
			>
			</roulette>
			<div v-else>
				<v-img :src="require('@/assets/img/leslycvip/logo.png')"></v-img>
			</div>
		</v-col>
		<v-col cols="4">

		</v-col>

	</v-row>
</template>

<style scoped lang="scss">
</style>
<style>
#inspire {
	background-image: url("../../../assets/img/leslycvip/background.jpg");
}
</style>
